
import { Component } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { RoleService } from './core/services/role.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet]
})
export class AppComponent {
  userRoles: string[] = [];

  constructor(
    private roleService: RoleService,
    private router: Router
  ) {}

  ngOnInit() {
    this.roleService.getRole().subscribe((role) => {
      this.userRoles = role;
      // this.verifAcces();
    });
  }

  // vérification d'accès à la racine de l'application
  verifAcces() {
    let roles = this.userRoles;
    let profil_admin = roles.includes('pama-admin');

    let profil_demandeur = roles.includes('pama-user');
    let profil_valideur = roles.includes('pama-valideur');
    /* let profil_directeur = roles.includes('pama-directeur');
    let profil_gestionnaire = roles.includes('pama-gestionnaire-paie');

    let profil_responsable = roles.includes('pama-responsable');
    let profil_assistant_responsable = roles.includes('pama-assistant-responsable'); */

    // broadcast vers la page d'erreur
    if (!profil_admin && !profil_demandeur && !profil_valideur) {
      this.router.navigate(['/', 'acces-interdit']);
    }
    // redirection normale, nécessaire pour rétablir la navigation
    else {
      this.router.navigate([window.location.pathname]);
    }
  }
}
